import { AxiosRequestConfig, AxiosStatic } from "axios";
import { get, set } from "lodash";
import { useAuth } from "@/store/auth";
import { getActivePinia } from "pinia";

const addBearer = (
  config: AxiosRequestConfig,
  store = getActivePinia()
): AxiosRequestConfig => {
  const token = useAuth(store).accessToken;
  if (token) {
    set(config, "headers.Authorization", `Bearer ${token}`);
  }
  return config;
};

let retried = false;

export default function axiosConfig(
  axios: AxiosStatic,
  store = getActivePinia(),
  interceptor?: any
) {
  if (interceptor) {
    axios.interceptors.request.eject(interceptor);
  }
  axios.interceptors.request.use(function (config) {
    if (config.url) {
      addBearer(config);
    }
    return config;
  });

  axios.interceptors.response.use(
    (r) => {
      // Handle response at intercept
      return r;
    },
    function (err) {
      if (get(err, "response.status") !== 401 || retried) {
        retried = false;
        return Promise.reject(err);
      }
      retried = true;
      return useAuth(store)
        .getCurrentUserInfo()
        .then(() => axios.request(addBearer(err.config)));
    }
  );
}
